var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Button, Typography, useBreakpoint } from '@airtel/air-design-system';
import { InfoListConstants } from '../../InfoListWidgetsConstants';
function ClickableTypography(props) {
  var onPress = props.onPress,
    onUserAction = props.onUserAction,
    text = props.text,
    type = props.type,
    color = props.color,
    _props$isClickable = props.isClickable,
    isClickable = _props$isClickable === void 0 ? false : _props$isClickable,
    onTextPressMetaData = props.onTextPressMetaData,
    id = props.id,
    restProps = __rest(props, ["onPress", "onUserAction", "text", "type", "color", "isClickable", "onTextPressMetaData", "id"]);
  var _useBreakpoint = useBreakpoint({
      returnAsObject: true
    }),
    isLargeScreen = _useBreakpoint.isLargeScreen;
  var onPressHandler = event => {
    if (onPress) onPress(event);
    onTextPressMetaData && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
      id
    }, onTextPressMetaData), Object.assign({
      id
    }, restProps)));
  };
  if (!isClickable) {
    return _jsx(Typography, Object.assign({
      testID: "InfoList-Non-Clickable-Text",
      text: text,
      color: color
    }, restProps, {
      type: type
    }));
  } else {
    return _jsx(Button, {
      testID: "InfoList-Clickable-Text",
      size: isLargeScreen ? InfoListConstants.MD : InfoListConstants.SM,
      buttonType: InfoListConstants.TERTIARY,
      title: text,
      onPress: onPressHandler
    });
  }
}
export default ClickableTypography;